import HeroWImageBlock from "./block-library/heroes/HeroWImageBlock";
import PageBlock from "./block-library/sections/page/PageBlock";
import TextSectionBlock from "./block-library/sections/texts/TextSectionBlock";
import HeaderBlock from "./globals/headers/HeaderBlock";
import TextWImageSectionBlock from "./block-library/sections/TextWImageSectionBlock";
import TextColumnSectionBlock from "./block-library/sections/texts/TextColumnSectionBlock";
import HeroSimpleBlock from "./block-library/heroes/HeroSimpleBlock";
import MembersGridBlock from "./block-library/sections/grids/MembersGridBlock";
import ContactBlock from "./block-library/sections/contacts/ContactBlock";
import ImageSimpleBlock from "./block-library/images/ImageSimpleBlock";
import IframeBlock from "./block-library/components/IframeBlock";
import SpotlightNewsGridBlock from "./block-library/sections/grids/SpotlightNewsGridBlock";
import SpotlightInstrumentInfoBarBlock from "./block-library/sections/grids/SpotlightInstrumentInfoBarBlock";
import SpotlightReportAndProspectBlock from "./block-library/sections/grids/SpotlightReportAndProspectBlock";
import SpotlightInstrumentStockPriceChartBlock from "./block-library/sections/SpotlightInstrumentStockPriceChartBlock";
import TextOnlySectionBlock from "@/library/sections/texts/TextOnlySection";

const StoryblokComponents = {
  // components
  HeroWImage: HeroWImageBlock,
  HeroSimple: HeroSimpleBlock,
  ImageSimple: ImageSimpleBlock,
  Iframe: IframeBlock,

  // sections
  Header: HeaderBlock,
  TextSection: TextSectionBlock,
  TextWImageSection: TextWImageSectionBlock,
  TextColumnSection: TextColumnSectionBlock,
  TextOnlySection: TextOnlySectionBlock,
  MembersSection: MembersGridBlock,
  ContactSection: ContactBlock,
  SpotlightNewsSection: SpotlightNewsGridBlock,
  SpotlightInstrumentInfoBarSection: SpotlightInstrumentInfoBarBlock,
  SpotlightReportAndProspectSection: SpotlightReportAndProspectBlock,
  SpotlightInstrumentStockPriceChartSection:
    SpotlightInstrumentStockPriceChartBlock,
  // page types
  page: PageBlock,
};

export default StoryblokComponents;
